import { createContext, useContext, useEffect, useState } from "react";
import { useApi } from "@/lib/api";

const MeContext = createContext(null);
export const useMe = () => useContext(MeContext);

export function MeProvider({ children }) {
  const api = useApi();
  const [me, setMe] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get("/me").then((r) => setMe(r.data)).catch(() => setError(true));
  }, [api]);

  if (error) {
    return <div className="p-8 text-center text-slate-400" data-testid="me-error">Não foi possível carregar seu perfil. Recarregue a página.</div>;
  }
  if (!me) {
    return (
      <div className="min-h-screen grid place-items-center" data-testid="me-loading">
        <div className="loader-bar" />
      </div>
    );
  }
  return <MeContext.Provider value={me}>{children}</MeContext.Provider>;
}
